export default "__VITE_ASSET__CSlB1W4Q__"